import { render, staticRenderFns } from "./ordinary-full.vue.js?vue&type=template&id=146fa396&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ordinary-full.vue?vue&type=template&id=146fa396&scoped=true"
import script from "./ordinary-full.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ordinary-full.vue?vue&type=script&lang=js"
export * from "./ordinary-full.vue.js?vue&type=script&lang=js!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ordinary-full.vue?vue&type=script&lang=js"
import style0 from "./ordinary-full.vue.scss?vue&type=style&index=0&id=146fa396&lang=scss&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ordinary-full.vue?vue&type=style&index=0&id=146fa396&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146fa396",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('146fa396')) {
      api.createRecord('146fa396', component.options)
    } else {
      api.reload('146fa396', component.options)
    }
    module.hot.accept("./ordinary-full.vue.js?vue&type=template&id=146fa396&scoped=true!=!../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./ordinary-full.vue?vue&type=template&id=146fa396&scoped=true", function () {
      api.rerender('146fa396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AIHelper/sceneAssistant/ordinary-full.vue"
export default component.exports